export default __webpack_public_path__ + "static/media/2.d41120cb.png";